import yup from "yup";

export function isRequiredBySchema(field: string | undefined, schema: yup.AnyObjectSchema) {
  if (field === undefined || field == null || schema == null) {
    return false;
  }
  return schema.fields[field]?.exclusiveTests?.required || false;
}
